/* eslint react/prop-types: 0 */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import { persistStore, autoRehydrate } from 'redux-persist';
import { asyncSessionStorage } from 'redux-persist/storages';

import { compose, createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';

// Component, Route, and Lib
import routeDidUpdate from './actions/actions-router';
import { initAuthPrompt } from './actions/actions-auth-prompt';
import Page from '../lib/page';

import largeScreenRoutes from './routes/LargeScreenRoutes';
import rootReducer from './reducers/index';
import HelpApp from './components/HelpApp';
import getHistory from '../lib/HistoryHelper';
import { getParsedPathName } from '../lib/location-helper';
import getOpenDisputes from './actions/action-dispute-transactions';
import { isTrackersEnabledInHome } from '../lib/covidHelper';

const middlewares = [
  thunkMiddleware,
];

if (process.env.NODE_ENV !== 'production') {
// eslint-disable-next-line  global-require
  const defaultLogger = require('redux-logger');

  middlewares.push(defaultLogger.createLogger());
}

const isLoggedIn = Page.isLoggedIn();

const store = createStore(rootReducer,
  undefined,
  compose(autoRehydrate(),
    applyMiddleware(...middlewares)));

persistStore(store, {
  storage: asyncSessionStorage,
  whitelist: ['modal'],
});

// Todo: below `basename` should be updated to `US`.
const history = getHistory();
const isHomePage = Page.isHomePage();

window.histTest = history;

const currentLocation = getParsedPathName(history.location);
history.push(currentLocation);

store.dispatch(routeDidUpdate(currentLocation));

// TODO: wire to acrtions-router after backend code

history.listen((location) => {
  store.dispatch(routeDidUpdate(location));
});

if (isLoggedIn && isHomePage) {
  // Initalize Auth prompt display logic for on-call users
  store.dispatch(initAuthPrompt(Page.isDisplayAuthPrompt()));
  // TODO: Remove this logic during covid -19 clean up
  // Adding tracker remote config check for Covid-19 Enable tracker
  if (isTrackersEnabledInHome()) {
    store.dispatch(getOpenDisputes());
  }
}

const routeConfig = largeScreenRoutes; // Using CSS to control left side display logic
Page.removeSession('showContactOptions');

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <HelpApp sideBar={routeConfig.sideBar} mainContainer={routeConfig.mainContainer} />
    </Router>
  </Provider>,
  document.querySelector('.smarthelp-react-app'),
);
